export const radius = (size: number) => {
    return `${size * 6}px`
}

export const spacing = (size: number) => {
    return `${size * 8}px`
}

export const COLOR_PRIMARY_GREEN = 'rgba(0,36,18,1)'

export const COLOR_DARK_BLUE = '#192A58'

export const COLOR_PRIMARY_RED = '#ED4042'

export const COLOR_DARK_RED = '#9E2A2C'

export const COLOR_ELEVATION = 'white'

export const COLOR_BACKGROUND = '#EAEAEA'

export const COLOR_GREEN = '#40ED51'

export const COLOR_YELLOW = '#EDD140'

export const COLOR_DISABLED = '#ccc'

export const COLOR_PRIMARY_BLACK = "#464648"

export const GREEN_GRADIENT = 'background: linear-gradient(90deg, rgba(0,36,18,1) 0%, rgba(52,116,29,1) 100%);'